import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled, { css } from 'styled-components';
import { Box } from '@miro-site/core';
var Card = styled(Box).attrs(function (_ref) {
  var _ref$$hasBorder = _ref.$hasBorder,
      $hasBorder = _ref$$hasBorder === void 0 ? true : _ref$$hasBorder,
      theme = _ref.theme,
      _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles;
  return {
    $styles: _objectSpread({
      borderRadius: 16,
      border: $hasBorder ? "1px solid ".concat(theme.colors.lightGray) : '1px solid transparent'
    }, $styles)
  };
}).withConfig({
  displayName: "Card",
  componentId: "sc-1mig80a-0"
})(["", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return css(["", " ", " ", " ", ""], theme.mq.small(css(["box-shadow:0 ", " ", " var(--wcds-card-box-shadow-color);"], theme.multipliers.small(4), theme.multipliers.small(12))), theme.mq.mediumDown(css(["box-shadow:0 ", " ", " var(--wcds-card-box-shadow-color);"], theme.multipliers.mediumDown(4), theme.multipliers.mediumDown(12))), theme.mq.mediumUp(css(["box-shadow:0 ", " ", " var(--wcds-card-box-shadow-color);"], theme.multipliers.mediumUp(4), theme.multipliers.mediumUp(12))), theme.mq.large(css(["box-shadow:0 ", " ", " var(--wcds-card-box-shadow-color);"], theme.multipliers.large(4), theme.multipliers.large(12))));
}, function (_ref3) {
  var theme = _ref3.theme,
      $isFocused = _ref3.$isFocused;
  return $isFocused && theme.normalizeStyles(theme.focus.outlines["default"]);
});
export default Card;